// 발신 계정(문자 발송 대행 계정) 잔액 부족으로 인한 발송 실패를 판별하고,
// 대시보드/통계 화면에서 공통으로 사용하는 기준값을 모아둔 모듈.

// 백엔드(send-sms / process-split-sends)가 잔액 부족 시 저장하는 정규화 사유 문구
export const BALANCE_FAILURE_REASON = "발신 계정 잔액 부족 (문자 발송 계정 충전 필요)";

// 알림을 띄울 최근 조회 기간 (시간 단위)
export const BALANCE_FAILURE_LOOKBACK_HOURS = 24;

/**
 * 발송 실패 사유 문자열이 "잔액 부족" 계열인지 판별한다.
 * 신규 정규화 문구뿐 아니라 예전에 원문 그대로 저장된 provider 오류까지 포함한다.
 */
export function isBalanceFailureReason(reason?: string | null): boolean {
  if (!reason) return false;
  const s = String(reason).toLowerCase();
  return (
    s.includes("잔액") ||
    s.includes("not enough balance") ||
    s.includes("not enough credit") ||
    s.includes("insufficient balance") ||
    s.includes("no credit")
  );
}